module.exports = __webpack_public_path__ + "edee310c820c3c648384d0e1f0030de8.pdf";